import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75" }
const _hoisted_2 = { class: "relative w-full bg-white rounded sm:w-7/12 max-w-9/12 min-w-5/12" }
const _hoisted_3 = { class: "relative px-2 py-2 text-center text-white uppercase rounded-t bg-primary" }
const _hoisted_4 = { class: "px-6 py-5 space-y-2" }
const _hoisted_5 = {
  key: 0,
  class: "flex py-5 justify-evenly"
}

interface Props {
  header: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    header: null
  },
  emits: ["close"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(__props.header) + " ", 1),
        _createElementVNode("div", {
          class: "absolute top-0 bottom-0 right-0 px-4 py-2 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_fa_icon, { icon: "times" })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})